/**
 * Manifest des changelogs versionnes pour le bandeau "What's new" Tauri.
 *
 * - **Clef** : version semver matchant `tauri.conf.json -> version`.
 * - **highlights** : liste de bullet points courts en FR, EN, ES. La modal
 *   sera shown UNE FOIS apres une update vers cette version (tracking via
 *   localStorage `lastSeenVersion`).
 * - **date** : ISO date du release pour affichage.
 *
 * Convention : a chaque tag `v*` (Phase 2 release), AJOUTER une entree ici
 * pour la version sortie. Si l'entree est absente la modal n'apparait pas
 * (silent update = OK pour patches mineurs).
 */

export interface ChangelogEntry {
  date: string; // ISO YYYY-MM-DD
  highlights: {
    fr: string[];
    en: string[];
    es: string[];
  };
}

export const CHANGELOG_MANIFEST: Record<string, ChangelogEntry> = {
  "0.1.17": {
    date: "2026-06-18",
    highlights: {
      fr: [
        "F11 met le cockpit en vrai plein écran (masque la barre des tâches Windows)",
        "Réorganise les icônes de la barre des tâches par glisser-déposer",
        "Personnalise la couleur d'accent du cockpit + le fond d'écran (Personnaliser le thème)",
      ],
      en: [
        "F11 puts the cockpit in true fullscreen (hides the Windows taskbar)",
        "Reorder the taskbar icons by drag-and-drop",
        "Customize the cockpit accent color + wallpaper (Customize theme)",
      ],
      es: [
        "F11 pone el cockpit en pantalla completa real (oculta la barra de tareas de Windows)",
        "Reordena los iconos de la barra de tareas arrastrando y soltando",
        "Personaliza el color de acento del cockpit + el fondo de pantalla (Personalizar tema)",
      ],
    },
  },
  "0.1.16": {
    date: "2026-05-22",
    highlights: {
      fr: [
        "Fix cross-platform Mac : selects natifs corriges, titlebar Overlay (traffic-lights restaures)",
        "Installation depuis le browser : PWA mobile (Android prompt + tuto iOS) + bouton telecharger intelligent",
        "Auto-updater Tauri scaffolde (toast + plugin, inerte tant que keys Ed25519 pas en place)",
        "Pipeline release 2-repos : binaires publies dans xeylabot/dozka-cockpit-releases public",
      ],
      en: [
        "Cross-platform Mac fix: native selects corrected, titlebar Overlay (traffic-lights restored)",
        "Browser install: mobile PWA (Android prompt + iOS tutorial) + smart download button",
        "Tauri auto-updater scaffolded (toast + plugin, inert until Ed25519 keys are in place)",
        "Release pipeline 2-repos: binaries published to public xeylabot/dozka-cockpit-releases",
      ],
      es: [
        "Corrección cross-platform Mac: selects nativos corregidos, titlebar Overlay (traffic-lights restaurados)",
        "Instalación desde browser: PWA móvil (prompt Android + tutorial iOS) + botón de descarga inteligente",
        "Auto-updater Tauri preparado (toast + plugin, inerte hasta que las llaves Ed25519 estén en su lugar)",
        "Pipeline de release 2-repos: binarios publicados en el repo público xeylabot/dozka-cockpit-releases",
      ],
    },
  },
};
